import { render, staticRenderFns } from "./DetailLoader.vue?vue&type=template&id=5f52fd78&scoped=true&lang=html&"
import script from "./DetailLoader.vue?vue&type=script&lang=js&"
export * from "./DetailLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52fd78",
  null
  
)

export default component.exports